import * as Sentry from '@sentry/nextjs';

export function sentryEnabled() {
  return process.env.SENTRY_ENABLED === 'true' && !!process.env.SENTRY_DSN;
}

export function sentryInitConfig(dsn: string | undefined, enabledFlag: string | undefined) {
  const enabled = enabledFlag === 'true' && !!dsn;
  const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE || process.env.SENTRY_RELEASE;

  return {
    dsn: enabled ? dsn : undefined,
    enabled,
    environment: process.env.NODE_ENV,
    tracesSampleRate: process.env.NODE_ENV === 'development' ? 1 : 0.1,
    ...(release ? { release } : {}),
  };
}

export function captureApiServerError(status: number, message: string | undefined, extra: { path: string; method: string; userId?: string }) {
  try {
    if (status < 500 || !sentryEnabled()) return;

    const error = new Error(message || `API responded ${status}`);
    error.name = 'ApiServerError';

    Sentry.withScope((scope) => {
      scope.setTag('http.status_code', String(status));
      scope.setTag('path', extra.path);
      scope.setTag('method', extra.method);
      extra.userId && scope.setUser({ id: extra.userId });
      scope.setExtra('apiResponse', extra);
      Sentry.captureException(error);
    });
  } catch {
    // Reporting must not change the API response.
  }
}
